module.exports = __webpack_public_path__ + "img/Rhythmic-Gymnastics.0562540c.png";